import { PackageOpen } from 'lucide-react';

// Placeholder della Fase 3 (SOAR): la struttura è già quella prevista, le azioni verranno
// collegate al motore di orchestrazione quando sarà sviluppato.
export default function SoarExecutionHistory() {
  return (
    <div className="p-8 flex flex-col items-center">
      <PackageOpen size={40} className="text-gray-300 mb-3" />
      <p className="text-sm font-medium text-gray-700">No executed SOAR playbooks and actions.</p>
      <p className="text-xs text-gray-400 mb-6">The response orchestration engine is planned for Phase 3.</p>

      <div className="w-full max-w-xl space-y-3">
        {[
          {
            title: 'Execute SOAR Playbook',
            text: 'Implement fully or partially automated responses through playbook orchestration to standardize incident handling, integrating with third-party devices for investigation, fixing and notification.',
          },
          {
            title: 'Execute SOAR Action',
            text: 'Execute individual response actions, including connectivity tests and custom responses on third-party devices.',
          },
        ].map(card => (
          <div key={card.title} className="border border-gray-200 rounded-lg p-4 flex items-start gap-4">
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-900 mb-1">{card.title}</div>
              <p className="text-xs text-gray-500">{card.text}</p>
            </div>
            <button disabled className="btn-secondary opacity-40 cursor-not-allowed shrink-0">Execute</button>
          </div>
        ))}
      </div>
    </div>
  );
}
